<template>
  <div class="maincontainer">
    <div class="tabback">
      <div class="tab">
        <div class="inner">
            <a v-for="(data, key) in tabs" :key="key" @click="switchTab(data.index)" :class="{ active: tab === data.index }">
              {{ data.label }}
            </a>
        </div>
      </div>
    </div>
    <div class="content">
      <template v-if="tab === 0">
        <TakeOut @showUsage="showUsageModal()" />
      </template>
      <template v-else-if="tab === 1">
        <NetOrder />
      </template>
      <template v-else-if="tab === 2">
        <Delivery />
      </template>
    </div>
    <net-shop-take-out-usage
      v-if="showUsage"
      @dismissUsage="showUsage = false"
    />
  </div>
</template>

<script>
import TakeOut from './TakeOut'
import NetOrder from './NetOrder'
import Delivery from './Delivery'
import NetShopTakeOutUsage from './NetShopTakeOutUsage'
import { mapActions } from 'vuex'

export default {
  name: 'NetShop',
  components: {
    NetOrder,
    TakeOut,
    Delivery,
    NetShopTakeOutUsage
  },
  data() {
    return {
      title: 'ネットショップ',
      tabs: [
        { index: 0, label: 'ネット注文' },
        { index: 1, label: 'ネット通販' },
        { index: 2, label: '宅配サービス' }
      ],
      tab: 0,
      showUsage: false
    }
  },
  created() {
    if (this.$route.query.tab) {
      this.tab = parseInt(this.$route.query.tab)
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.tab = parseInt(to.query.tab)
    if (!this.tab || this.tab.isNaN()) {
      this.tab = 0
    }
    this.switchTab(this.tab)
    next()
  },
  methods: {
    ...mapActions('Modal', ['action_ToggleModal']),
    switchTab(index) {
      this.tab = index
      // this.$router.replace({ query: { tab: index } })
    },
    showUsageModal() {
      this.showUsage = true
    }
  }
}
</script>

<style lang="scss" scoped>
.maincontainer {
  background-color: #ffffff;
  min-height: 100vh;

  .tabback {
    background-color: var(--background-color);

    .tab {
      padding: 20px 20px 20px;

      .inner {
        height: 30px;
        width: 100%;
        border: 1px solid #66160E;
        border-radius: 4px;
        display: flex;
        overflow: hidden;
        background: #ffffff;

        a {
          text-align: center;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 12px;
          color: #66160E;
          border-right: 1px solid #66160E;

          &.active {
            background: #66160E;
            color: #ffffff;
          }

          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }

  .content {
    flex: 1;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
